"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsPrefetchLinks = void 0;
const react_1 = __importDefault(require("react"));
const AssetsPrefetchLinks = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("link", { rel: "preconnect", href: "https://cdn.evbstatic.com" }),
    react_1.default.createElement("link", { rel: "dns-prefetch", href: "https://cdn.evbstatic.com" }),
    react_1.default.createElement("link", { rel: "preconnect", href: "https://img.evbuc.com" }),
    react_1.default.createElement("link", { rel: "dns-prefetch", href: "https://img.evbuc.com" })));
exports.AssetsPrefetchLinks = AssetsPrefetchLinks;
//# sourceMappingURL=AssetsPrefetchLinks.js.map